<div class="search-container d-inline-block float-lg-none footer-md-100">
  <a
    #triggerElement
    (click)="!avoidFocus ? open() : null"
    [attr.tabindex]="avoidFocus ? -1 : 0"
    aria-haspopup="true"
    [ngClass]="
      origin === 'footer'
        ? 'search-text'
        : 'search icon-search-icon circle-outline'
    "
    (keydown)="handleFocusEvent($event)"
    href="javascript:void(0);"
    aria-label="search-button"
    id="search-button"
  >
    <ng-template [ngIf]="origin === 'footer'">
      <ng-container *ngIf="searchText">{{ searchText }}</ng-container>
      <span
        class="search d-inline-block icon-search-icon circle-outline float-icon-right"
      ></span>
    </ng-template>
    <img
      alt="Search"
      src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    />
  </a>
</div>
